import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Toast from 'vue-toastification'
import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
import { PiniaVuePlugin } from 'pinia'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import pinia from './store/pinia'
import store from './store'

import router from './router'

Vue.config.productionTip = false
Vue.use(Toast)
Vue.use(VueTheMask)
Vue.use(PiniaVuePlugin)
Vue.use(VueRouter)

new Vue({
  pinia,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
